import React from 'react';
import {useForm} from "react-hook-form";

type InputFieldProps = {
    label: string
    name: string
    className: string
    register: ReturnType<typeof useForm>['register']
    errors: ReturnType<typeof useForm>['formState']['errors']
    required?: boolean
    disabled?: boolean
    placeholder?: string
    type?: string
    validation?: Record<string, any>;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomInput: React.FC<InputFieldProps> = ({
       label,
       name,
       register,
       errors, 
       className,
       type = 'text', 
       required = false,
       disabled = false,
       placeholder,
       validation = {},
       onChange,
       ...props
   }) => {
    const hasError = Boolean(errors[name])
    return (
        <div className="mb-3">
            <label htmlFor={name} className="form-label">
                {label}
                {required && <sup className="text-danger">*</sup>}
            </label>

            <input
                id={name}
                {...register(name, {
                    required: required && 'This field is required.',
                    ...validation
                })}
                type={type}
                className={
                    className +
                    (hasError ? ' is-invalid' : '')
                }
                placeholder={label}
                disabled={disabled}
                onChange={onChange}
                {...props}
            />

            {hasError && (
                <div className="invalid-feedback">
                    {errors[name]?.message as string}
                </div>
            )}
        </div>
    )
}

export default CustomInput
